import logo from "./logo.svg";
import "./App.css";
import { Routes, Route, Navigate, Link } from "react-router-dom";
import Navbar from "./navbar";
import Sidebar from "./sidebar";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import { get, onValue, ref, set } from "firebase/database";
import { auth, database } from "./firebase";
import {
  sendEmailVerification,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import Departments from "./departments";
import Users from "./user";
import Tickets from "./tickets";
import Overview from "./overview";
import AccountSettings from "./accountSettings";
import Categories from "./categories";

function App() {
  const [role, setRole] = useState("user");
  const userId = Cookies.get("userid");
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState(0); // 0=login, 1=register, 2=forgot

  // Form fields
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const authenticated = Cookies.get("authenticated") === "true";

  const [sidebarToggled, setSidebarToggled] = useState(() => {
    return localStorage.getItem("sidebarToggled") === "true";
  });

  // Update body class based on toggle
  useEffect(() => {
    document.body.classList.toggle("sidebar-toggled", sidebarToggled);
    localStorage.setItem("sidebarToggled", sidebarToggled.toString());
  }, [sidebarToggled]);

  // Fetch user role when logged in
  useEffect(() => {
    if (!userId) {
      setShowModal(true);
      return;
    }

    const userRef = ref(database, "helpdesk/users/" + userId);
    const unsubscribe = onValue(
      userRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const user = snapshot.val();
          setRole(user.role || "user");
        }
      },
      (error) => {
        console.error("Error fetching role:", error);
      }
    );

    return () => unsubscribe();
  }, [userId]);

  const Logout = async () => {
    await signOut(auth);
    Cookies.remove("userid");
    Cookies.remove("role");
    setShowModal(true);
  };

  return (
    <div id="wrapper">
      {/* Sidebar */}
      <Sidebar
        sidebarToggled={sidebarToggled}
        toggleSidebar={() => {
          if (window.innerWidth > 768) {
            // Close all open submenu collapses
            document.querySelectorAll(".collapse.show").forEach((el) => {
              el.classList.remove("show");

              // Also add 'collapsed' class back to its trigger
              const trigger = document.querySelector(
                `[data-toggle="collapse"][href="#${el.id}"], [data-toggle="collapse"][data-target="#${el.id}"]`
              );
              if (trigger) {
                trigger.classList.add("collapsed");
                trigger.setAttribute("aria-expanded", "false");
              }
            });
          }
          setSidebarToggled(!sidebarToggled);
        }}
      />

      {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">
        {/* Main Content */}
        <div id="content">
          {/* Topbar */}
          <Navbar toggleSidebar={() => setSidebarToggled(!sidebarToggled)} />

          {/* Begin Page Content */}
          <div className="container-fluid">
            <Routes>
              <Route path="/" element={<Navigate to="/overview" replace />} />
              <Route path="/overview" element={<Overview />} />
              <Route path="/tickets" element={<Tickets />} />
              <Route path="/settings" element={<AccountSettings />} />
              <Route path="/users" element={<Users />} />
              <Route path="/departments" element={<Departments />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/account" element={<AccountSettings />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
